import React, { Component } from 'react';
import './left-menu.scss';
import { API, isPC, InitConfig } from '../common/config';
import { Event } from '../common/event';
import { checkStatus,parseJSON  } from "../common/http";

export default class LeftMenu extends Component {

  constructor(props){
    super(props);
    this.category = null;
    this.state = {
      products: [],
      selectedId: -1
    }
  }
  transform() {
    Event.on('CategoryChange',async(v)=>{
      this.category = v;
      this.require();
    })
  }

  require() {
    let id = this.category.id;
    if(this.products) {
      this.updateDate(this.products, id);
      return;
    }
    this.products = [];
    fetch(API.getProjectByCId)
    .then(checkStatus)
    .then(parseJSON)
    .then(
        (data) => {
          this.products = data;
          this.updateDate(data, id);
        },
        (error)=>{
          this.setState({products: null});
        }
    );
  }

  updateDate(products,id) {
    let prds = [];
    products.forEach((p)=>{
      if(p.categoryId == id) {
        prds.push(p);
      }
    });

    this.setState({products: prds});
    if (InitConfig.productId) {
      let d = prds.find(v=>(v.id === InitConfig.productId));
      InitConfig.productId = null;
      this.select(d);
    } else if (isPC()) {
      this.select(prds[0]);
    }

  }

  componentDidMount() {
    // this.require(1);
    this.transform();
  }

  select(v){
    this.setState({selectedId:v.id})
    Event.emit('ProductChange',v);
    Event.emit('ShowRight',false);
  }




  render() {
    return (
      <div className="left-menu">
        <ul className="scroll_content">
          <li>
            <a>系列</a>
          </li>
          {
            this.state.products && this.state.products.map(v=>(
                <li key={v.id} className={this.state.selectedId === v.id ? 'selected': null} >
                  <a onClick={this.select.bind(this,v)}>{v.name}</a>
                </li>
            ))
          }
        </ul>
      </div>
    )
  }

}
